import React, { useState } from 'react';

import { TableDocumentList, ActionMenu } from '@ibinder/ui-common-core';

import { NOT_A_VALID_METADATAID } from '@ibinder/common-utils';

import { delete as CFDeleteIcon } from '@ibinder/common-icons';

import { UsersViewProps, UserViewType } from './Users.types';

import { TableWrapper } from './Users.styles';
import { getDefaultComparer } from '../../../../helpers/tableDocumentListHelper';

export const labels = {
  identityFunction: (str) => str
};

export const UsersView = ({
  data,
  onRemoveUser,
  selectedIds,
  setSelectedIds
}: UsersViewProps) => {
  const [sorting, setSorting] = useState<{
    field: string;
    desc: boolean;
  }>({
    field: 'name',
    desc: false
  });

  const userActionMenu = (user: UserViewType) => (
    <ActionMenu
      placement="right-start"
      actions={[
        {
          icon: CFDeleteIcon,
          action: 'Remove'
        }
      ]}
      onSelect={(action) => {
        onRemoveUser(user);
      }}
      labels={{
        identityFunction: (n) => n
      }}
    />
  );

  const headers: {
    id: string;
    name: string;
    propName: keyof UserViewType;
    Cell?: (tableData: any) => any;
  }[] = [
    {
      id: NOT_A_VALID_METADATAID,
      name: 'Name',
      propName: 'name'
    },
    {
      id: '1',
      name: 'E-Mail',
      propName: 'email'
    },
    {
      id: '2',
      name: 'Company',
      propName: 'companyname'
    },
    {
      id: '3',
      name: 'City',
      propName: 'companycity'
    }
  ];

  const onSort = (sortArgs: { id: string; desc: boolean }) => {
    setSorting({
      field: headers.find((h) => h.id === sortArgs.id)?.propName,
      desc: sortArgs.desc ?? false
    });
  };

  const users: UserViewType[] = !data
    ? []
    : data
        .map((u) => ({
          ...u,
          name: u.fullName, // prop 'name' is required for column with id=NOT_A_VALID_METADATAID
          companyname: u.company?.name,
          companycity: u.company?.city
        }))
        .map((u) => ({
          ...u,
          metadata: headers.map((h) => ({
            metadataElementId: h.id,
            value: u[h.propName],
            sortValue: u[h.propName]
          }))
        }))
        .sort((o1, o2) =>
          getDefaultComparer(o1, o2, sorting.field, sorting.desc)
        );

  return (
    <>
      <TableWrapper>
        <TableDocumentList
          setSelectedIds={setSelectedIds}
          selectedIds={selectedIds}
          hasSelectBox={true}
          headers={headers}
          documentQuery={users}
          sortBy={[
            {
              id: headers.find(({ propName }) => propName === sorting.field).id,
              desc: sorting.desc
            }
          ]}
          onSort={onSort}
          metadataElements={[]}
          actionMenu={userActionMenu}
          showDefaultFileIcon={false}
        />
      </TableWrapper>
    </>
  );
};
